import { styled } from "styled-components";

export const CostCardContainer = styled.div`
  display: flex;
  padding: 24px;
  width: 400px;
  gap: 24px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.default[50]};

  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }
`;

export const CountryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%%;
`;

export const PricesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const PriceLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Price = styled.div`
  color: ${({ theme }) => theme.colors.default[400]};
`;

export const Destination = styled.div`
  display: flex;
  width: 204px;
  align-items: center;
  gap: 12px;
`;

export const Flag = styled.div`
  display: flex;
  align-items: center;
`;
